<h1 mat-dialog-title style="text-align: center;">{{title}}</h1>
<div mat-dialog-content style="text-align: center;">
  <pre>{{description}}</pre>
</div>
<div mat-dialog-actions style="justify-content: center;">
  <button mat-button mat-raised-button (click)="onNoClick()">{{button_no}}</button>
  <button mat-button mat-raised-button color="primary" [mat-dialog-close]="true">{{button_yes}}</button>
</div>